module.exports = {"id":"189211","name":"Saúl Berjón","rating":"75","photo":"./data/images/photos/2/189211.png","club":{"name":"Real Oviedo","logo":"./data/images/clubs/RealOviedo.png"},"positions":["MG","MD","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SaulBerjon0.json
// module id = 3837
// module chunks = 0